import { render, staticRenderFns } from "./noticeContent.vue?vue&type=template&id=635cd4a0&scoped=true"
import script from "./noticeContent.vue?vue&type=script&lang=js"
export * from "./noticeContent.vue?vue&type=script&lang=js"
import style0 from "./noticeContent.vue?vue&type=style&index=0&id=635cd4a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "635cd4a0",
  null
  
)

export default component.exports